import React, { Component } from 'react';
import axios from "axios";
import InputMask from 'react-input-mask';

import api from '../../../api/';

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';


import CargaDatos from "./CargaDatos.js"
import Avanzar from "./Avanzar.js"
import Autorizar from "./Autorizar.js"
import Detail from "./Detail.js"
import NroPresupuestoModal from "./NroPresupuestoModal.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import Enums from "../EstadoEnum.js"

import dateFunctions from '../../functions/dateFunctions';


class CargaDeDatos extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "Etapas",
                    id: "cantEtapas",
                    // accessor: "cantEtapas",
                    accessor: (d)=> (d.cantEtapas && d.cantEtapas!=1) ? (d.cantEtapas) : ('-'),
                    show: true,
                    width: 50,
                    // private:true,
                },
                /*{
                    Header: "Etapa",
                    id: "etapa",
                    width: 50,
                    accessor: (d)=> (d.etapa && d.cantEtapas) ? ((d.cantEtapas!=1) ? (d.etapa + '/' + d.cantEtapas) : ('-')) : ('-'),
                    show: true,
                    className: "text-center",
                },*/
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fechaCertificacion",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaCertificacion),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />

                },
                {
                    Header: "Título",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa",
                    accessor: d => d.empresa,
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                },
                {
                    Header: "hash_c",
                    id: "hash_c",
                    accessor: d => d.hash_c,
                    show: false,
                    private:true,
                },
                {
                    Header: "id_pre",
                    id: "id_pre",
                    accessor: d => d.id_pre,
                    show: false,
                    private: true,
                },
                {
                    Header: "Certificación",
                    id: "reportable",
                    filterable: false,
                    className: "text-center",
                    accessor: d => (d.cod != null) ? (d.reportable && d.certificacionAutorizada ?
                        <a
                            target={"_blank"}
                            href={api.proyectos.solicitudes.certificado + d.hash_c + "/"}
                        >
                            DESCARGAR
                        </a> :
                            <div className="badge badge-danger">
                                NO AUTORIZADA
                            </div>) :
                                (
                                    d.strestado== "DATOS CARGADOS" ?
                                    (d.cod = d.codigo,
                                    <a
                                        target={"_blank"}
                                        href={api.proyectos.solicitudes.certificado + d.hash_c + "/"}
                                    >
                                        DESCARGAR
                                    </a> ) :
                                <NroPresupuestoModal
                                    onSubmit={this.onSubmit.bind(this)}
                                    id={() =>{ return d.id_pre}}
                                >
                                </NroPresupuestoModal>),
                    show: true,
                    width: 100,
                },
                {
                    Header: "Fecha De Carga Datos",
                    id: "fechaCertificacionCargaDatos",
                    accessor: "fechaCertificacionCargaDatos",
                    show: false,
                    private: true,
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    width: 200,
                    show: true,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="CARGANDO DATOS">CARGANDO DATOS</option>
                            <option value="DATOS CARGADOS">DATOS CARGADOS</option>
                        </select>,
                    accessor: d => {
                         let dateToShow = d.strestado == "CARGANDO DATOS" || d.fechaCertificacionCargaDatos == null? d.fechaCertificacion : d.fechaCertificacionCargaDatos;
                         return (
                              <div className={d.strestado == "CARGANDO DATOS" ? "badge badge-warning presupuestoStateLabel " : "badge badge-success presupuestoStateLabel"}>
                              {d.strestado}
                              <br></br>
                              <small>{dateFunctions.parseDateTime(dateToShow)}</small>
                              </div>
                         );
                    },
                },
                {
                    Header: "",
                    id: "certificacionAutorizada",
                    accessor: "certificacionAutorizada",
                    show: false,
                    private: true,
                },
            ]
        };
    }

    onSubmit()
    {
        this.setState({cont: !this.state.cont});
    }

    render() {
        let outerFilter = []
        if (!this.state.cont){
            outerFilter.push({
                id: 'pk',
                value: ''
            })
        }

        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        permission: 'certificacion_edit',
                        component: CargaDatos,
                    },
                    {
                        detail: true,
                        permission: 'certificacion_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'certificacion_aprove',
                        component: Autorizar,
                    },
                    {
                        edit: true,
                        permission: 'certificacion_next',
                        component: Avanzar,
                    },
                ]}

                apiUrl={api.proyectos.cargadatos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.cargadatos.export}
                outerFilter={[...outerFilter, ]}
                title={"Certificación"}
            />
        );
    }
}

export default CargaDeDatos;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento5/CargaDeDatos.js